import Modal from 'antd-mobile/lib/modal';

export const insertString = (str, index, item) => {
    var temp = str.split('');
    temp.splice(index, 0, item);
    return temp.join("")
}

export function uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (parseFloat('0.' + (+new Date() + '').split('').reverse().join('')) * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function confirm(title, onOk, getLang) {
    Modal.alert(title, '', [{
        text: getLang("00014", "取消"),
        onPress: () => {
        }
    }, {
        text: getLang("00032", "确定"),
        onPress: () => {
            onOk();
        }
    }])
}

let urlOption = {};

export function getUrlParam(key) {
    let searchStr = window.location.search.replace('?', '');
    // 外勤详情url中是#?，会导致解析错误，这边特殊处理一下
    let hashStr = window.location.hash.replace('#', '').replace('?', '');

    if (urlOption && key && urlOption[key]) {
        return urlOption[key]
    }

    searchStr.split('&').forEach((optStr) => {
        let index = optStr.indexOf('=');
        let key = optStr.substring(0, index);
        let value = optStr.substring(index + 1);

        urlOption[key] = value
    });

    hashStr.split('&').forEach((optStr) => {
        let index = optStr.indexOf('=');
        let key = optStr.substring(0, index);
        let value = optStr.substring(index + 1);

        if (key) {
            urlOption[key] = value
        }
    });
    console.log(urlOption)
    if (key) {
        return urlOption[key];
    }
    return urlOption;
}


export function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            return !!(typeof obj == 'object' && obj);
        } catch (e) {
            console.log('error：' + str + '!!!' + e);
            return false;
        }
    }
    console.log('It is not a string!');
}

export function createUUid(len) {
    len = len || 6;
    len = parseInt(len, 10);
    len = isNaN(len) ? 6 : len;
    const seed = '0123456789abcdefghijklmnopqrstubwxyzABCEDFGHIJKLMNOPQRSTUVWXYZ';
    const seedLen = seed.length - 1;
    let uid = '';
    while (len--) {
        uid += seed[Math.round(parseFloat('0.' + getRandomNum()) * seedLen)];
    }
    return uid;
}

export function getRandomNum() {
    const arr = new Uint16Array(1);
    const crypto = window.crypto || window.webkitCrypto
        || window.mozCrypto || window.oCrypto || window.msCrypto;
    crypto.getRandomValues(arr);
    return arr[0];
}

export function setStorage(key, val) {
    localStorage.setItem(key, val)
}

export function getStorage(key) {
    return localStorage.getItem(key)
}

export function removeStorage(key) {
    return localStorage.removeItem(key)
}

export function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}


export const getCookie = (sName) => {
    const sRE = "(?:; )?" + sName + "=([^;]*);?";
    const oRE = new RegExp(sRE);

    if (oRE.test(document.cookie)) {
        return RegExp["$1"];
    } else
        return null;
};

export const setCookie = (sName, sValue) => {
    const date = new Date();
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie = sName + "=" + sValue + ";expires=" + date.toGMTString() + ";path=/";
};